import styled from 'styled-components'

export const LogoImg = styled.img`
  alt: ume-logo;
  height: 51px;
`
